import React from 'react'
import SellableCardCarousel from '#src/components/SellableCardCarousel'
import SectionHeader from '#src/components/SectionHeader'
import SidebarAwareGrid from '#src/components/SidebarAwareGrid'
import { GridItem } from '@deal/components'
import { DepartmentSavedSellablesComponent } from '#src/generated/graphql'
import { withIdentity, WithIdentityProps } from '#src/containers/Identity'
import styles from './styles.css'

const FavoriteSellables: React.SFC<WithIdentityProps> = ({ myself }) => {
  // This is on the logged in home, but just in case
  if (!myself) {
    return null
  }

  return (
    <DepartmentSavedSellablesComponent
      variables={{
        query: {
          userId: myself.id
        }
      }}
    >
      {({ data }) => {
        if (
          data &&
          data.savedSellablesConnection &&
          data.savedSellablesConnection.edges.length > 0
        ) {
          const sellableList = data.savedSellablesConnection.edges.map(edge => edge.node.sellable)

          return (
            <section className={styles.sectionCarousel}>
              <div className={styles.sectionBorderCarousel}>
                <SidebarAwareGrid>
                  <GridItem col={2}>
                    <SectionHeader header="Your favorite products" />
                    <SellableCardCarousel sellables={sellableList} infinite={false} />
                  </GridItem>
                </SidebarAwareGrid>
              </div>
            </section>
          )
        }

        return null
      }}
    </DepartmentSavedSellablesComponent>
  )
}

export default withIdentity(FavoriteSellables)
